import {
  MOBILE_BREAKPOINT,
  PLOT_MARGIN_DESKTOP,
  PLOT_MARGIN_MOBILE
} from './constants.js';

/**
 * Headless responsive helpers. They don't reach into the DOM beyond
 * `window.matchMedia`; sizing of a specific container is handled by the
 * caller (Chart.svelte) via ResizeObserver.
 */

export function isMobileViewport() {
  return window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT}px)`).matches;
}

export function plotMargin(isMobile) {
  return isMobile ? PLOT_MARGIN_MOBILE : PLOT_MARGIN_DESKTOP;
}

/**
 * Compute inner plot dimensions from a container width.
 * `aspect` is height-to-width ratio used to derive height when the
 * container has no explicit height.
 */
export function plotSize(width, isMobile) {
  const m = plotMargin(isMobile);
  const aspect = isMobile ? 1.05 : 0.6;
  const height = Math.max(360, Math.min(640, Math.round(width * aspect)));
  return {
    width,
    height,
    innerW: Math.max(50, width - m.left - m.right),
    innerH: Math.max(50, height - m.top - m.bottom),
    margin: m
  };
}

export function debounce(fn, ms) {
  let t = null;
  return function (...args) {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), ms);
  };
}
